var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"toTop",on:{"click":_vm.scrollTop}},[_c('span',{staticClass:"text-light toTop__arrow"},[_vm._v("↑")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }